<template>
    <div class="mag-article-tools">
        <action
            name="link-light"
            class="print"
            with-icon="mdi-printer"
            :nochevron="true"
            :small="true"
            @click="printWindow()"
        >
            Imprimer
        </action>
    </div>
</template>

<script>
export default {
    methods: {
        printWindow() {
            window.print();
        },
    },
};
</script>

<style lang="sass" scoped>
.mag-article-tools
    display: flex
    justify-content: flex-end
.print
    color: white
@media print
    .mag-article-tools
        display: none
</style>
